export default __webpack_public_path__ + "static/media/loading.2890af3c.gif";